import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=15afc620&scoped=true&lang=html&"
import script from "./charts.vue?vue&type=script&lang=js&"
export * from "./charts.vue?vue&type=script&lang=js&"
import style0 from "./charts.vue?vue&type=style&index=0&id=15afc620&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15afc620",
  null
  
)

component.options.__file = "charts.vue"
export default component.exports